'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPE = undefined;
exports.processor = processor;
exports.default = put;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TYPE = exports.TYPE = '__YIELD_EFFECT_PUT__';

function processor(effect, _ref) {
  var dispatch = _ref.dispatch;
  var action = effect.payload.action;


  (0, _invariant2.default)((0, _isPlainObject2.default)(action), '"put" only supports dispatching plain object actions, but received ' + action);

  return Promise.resolve().then(function () {
    return dispatch(action);
  });
}

function put(action) {
  return {
    type: TYPE,
    payload: {
      action: action
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/redux-yield-effect/lib/effects/put.js